import styled from 'styled-components';
import { getHideStyes, getResponsiveStyles } from '../helpers';
import { spacing, spacingDebugColors } from '../../../defaultTheme';
const StackSpacer = styled.div `
  display: flex;
  flex-direction: row;
  flex: 1;
  height: ${({ size }) => `${spacing[size || 'base']}px`};

  ${({ debug, size, respondToBreakpoints, hideOnBreakpointDown, hideOnBreakpointUp, hideOnlyOnBreakpoints }) => {
    let styles = respondToBreakpoints
        ? getResponsiveStyles(size, ['height'], respondToBreakpoints)
        : '';
    styles += getHideStyes(hideOnBreakpointUp, hideOnBreakpointDown, hideOnlyOnBreakpoints, 'display: none;');
    // Add background when debug is true
    if (debug) {
        styles += `background-color: ${spacingDebugColors.stack};`;
    }
    return styles;
}}
`;
export default StackSpacer;
//# sourceMappingURL=subcomponents.js.map